<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{
            mode == "create" ? "Create payment record" : "Edit payment record "
          }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bInvoices.amtPaid") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.bInvoices.amtPaid')"
                  v-model="formData.amountPaid"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.paymentDate") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <vue-ctk-date-time-picker
                  v-model="formData.paymentDate"
                  :max-date="maxDate"
                  :onlyDate="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.selectDate')"
                />
              </div>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
        <div class="text-center mt-4 pb-4">
          <button
            :disabled="isButtonDisabled ? true : false"
            class="ep-btn ep-primary"
            @click="
              mode === 'create' ? createPayment($event) : updatePayment($event)
            "
          >
            {{ mode == "create" ? "Create" : "Update" }}
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddPayment",
  title: "Add branch lease payment record :: Epump Portal",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
  },
  data() {
    return {
      branch: "",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      formData: {
        amountPaid: 0,
        paymentDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      branchSpaces: [],
      branchSpace: "",
      mode: "create",
      isButtonDisabled: false,
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Create Branch space :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    if (this.$route.params.paymentId) {
      this.mode = "edit";
      this.formData.amountPaid = JSON.parse(this.$route.query.data).amountPaid;
      this.formData.paymentDate = JSON.parse(
        this.$route.query.data
      ).paymentDate;
    }
  },
  beforeDestroy() {},
  methods: {
    createPayment($event) {
      $event.preventDefault();
      for (let [key, value] of Object.entries(this.formData)) {
        if (!value) {
          this.$toast.open({
            message: `${key} ${$t("text.bLease.isRequest")}`,
            type: "error",
            duration: 5000,
          });
          return;
        }
      }

      let data = {
        amountPaid: Number(this.formData.amountPaid),
        paymentDate: this.formData.paymentDate,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Lease/PaymentRecords/Add/${this.$route.query.leaseId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            path: `/Retail-Outlet/lease-payments/${this.$route.params.leaseId}`,
            query: {
              companyId: this.$route.query.companyId
                ? this.$route.query.companyId
                : this.branch.companyId,
              branchId: this.$route.query.branchId
                ? this.$route.query.branchId
                : this.branch.id,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
              leaseId: this.$route.params.leaseId,
            },
          });
          this.$toast.open({
            message: this.$t("text.bLease.successfullyCreatedLease"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    updatePayment($event) {
      $event.preventDefault();
      // console.log(this.formData);
      for (let [key, value] of Object.entries(this.formData)) {
        if (!value) {
          this.$toast.open({
            message: `${key} ${$t("text.bLease.isRequest")}`,
            type: "error",
            duration: 5000,
          });
          return;
        }
      }
      let data = {
        amountPaid: Number(this.formData.amountPaid),
        paymentDate: this.formData.paymentDate,
      };

      console.log(data);

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Lease/PaymentRecords/Edit/${this.$route.query.paymentId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            path: `/Retail-Outlet/lease-payments/${this.$route.params.leaseId}`,
            query: {
              companyId: this.$route.query.companyId
                ? this.$route.query.companyId
                : this.branch.companyId,
              branchId: this.$route.query.branchId
                ? this.$route.query.branchId
                : this.branch.id,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
              leaseId: this.$route.params.leaseId,
            },
          });
          this.$toast.open({
            message: this.$t("text.bLease.successfullyUpdatedLease"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getPayment() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/${this.$route.query.spaceId}`,
          configObject.authConfig()
        )
        .then((response) => {
          // this.formData = response.data
          this.formData.propertyName = response.data.name;
          this.formData.propertyDescription = response.data.description;
          this.formData.numberOfRooms = response.data.rooms;
          this.formData.numberOfRestRooms = response.data.restrooms;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
